module.exports = __webpack_public_path__ + "static/img/2发展历程.d743729.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/2发展历程.png
// module id = n+7A
// module chunks = 0